import FormTitle from 'platform/forms-system/src/js/components/FormTitle';
import { toggleValues } from 'platform/site-wide/feature-toggles/selectors';
import { isLOA3 } from 'platform/user/selectors';
import { TOGGLE_NAMES } from 'platform/utilities/feature-toggles';
import { focusElement } from 'platform/utilities/ui';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import EnrollmentStatus from '../components/IntroductionPage/EnrollmentStatus';
import OmbInfo from '../components/IntroductionPage/GetStarted/OmbInfo';
import ProcessDescription from '../components/IntroductionPage/GetStarted/ProcessDescription';
import content from '../locales/en/content.json';
import {
  selectHasApplyStatus,
  selectHealthEnrollmentStatus,
  selectVesRecordFound,
} from '../selectors';

const selectRenderConditions = state => {
  const { loading, hasServerError } = selectHealthEnrollmentStatus(state);
  const hasApplyStatus = selectHasApplyStatus(state);
  const vesRecordFound = selectVesRecordFound(state);
  const isESOverrideEnabled =
    toggleValues(state)[TOGGLE_NAMES.hcaEnrollmentStatusOverrideEnabled];
  const isUserLOA3 = isLOA3(state);

  const showEnrollmentStatus =
    isUserLOA3 && (vesRecordFound || hasServerError) && !isESOverrideEnabled;

  const showOmbInfo = showEnrollmentStatus
    ? hasApplyStatus && !hasServerError
    : true;

  return {
    showEnrollmentStatus,
    showOmbInfo,
    loading,
  };
};

const IntroductionPage = ({ route }) => {
  const { loading, showEnrollmentStatus, showOmbInfo } = useSelector(
    selectRenderConditions,
    shallowEqual,
  );

  useEffect(() => {
    if (!loading) focusElement('.schemaform-intro h1');
  }, [loading]);

  return (
    <div className="schemaform-intro">
      <FormTitle
        title={content['form-title']}
        subTitle={content['form-subtitle']}
      />

      {loading ? (
        <va-loading-indicator
          message={content['load-enrollment-status']}
          class="vads-u-margin-y--4"
          set-focus
        />
      ) : (
        <>
          {showEnrollmentStatus ? (
            <EnrollmentStatus route={route} />
          ) : (
            <ProcessDescription route={route} />
          )}
          {showOmbInfo && <OmbInfo />}
        </>
      )}
    </div>
  );
};

IntroductionPage.propTypes = {
  route: PropTypes.shape({
    formConfig: PropTypes.shape({
      downtime: PropTypes.object,
      formId: PropTypes.string,
      prefillEnabled: PropTypes.bool,
      savedFormMessages: PropTypes.object,
    }),
    pageList: PropTypes.array,
  }),
};

export default IntroductionPage;
